import React, { MutableRefObject } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { GeneralIconTag } from '~/common/define/icon'
import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import SearchIconTextBox from '~/components/molecules/textbox/SearchIconTextBox'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import { TextBoxSize } from '~/components/atoms/textbox/TextBox'
import TooltipWrapper from '~/components/wrapper/tooltip/TooltipWrapper'

interface Props {
  onSearch(text: string): void
  onAdd(): void
  searchPlaceholder: string
  newTooltipText: string
  color: SpaceColor
  menuNewRef?: MutableRefObject<any>
}

const NavigationMenuSupport = ({onSearch, onAdd, searchPlaceholder, newTooltipText, color, menuNewRef}: Props) => {
  return (
    <div className={styles.support}>
      <SearchIconTextBox
        onChangeText={onSearch} placeholder={searchPlaceholder} alwaysActive
        size={TextBoxSize.SMALL}
      />
      <TooltipWrapper text={newTooltipText} onClick={onAdd} wrapRef={menuNewRef}>
        <Icon tag={GeneralIconTag.ADD_CROSS} size={IconSize.SMALL} fillColor={IconColor.WHITE}
              frame={IconFrame.CIRCLE} clickableColor={color} bgColor={color}/>
      </TooltipWrapper>
      <style jsx>{`
        div {
          background: ${lightenColor(color, ColorWeight.FEATHER)};
        }
     `}</style>
    </div>
  )
}

export default NavigationMenuSupport